import * as React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NoPage() {
  const { t } = useTranslation();
  return (
    <Box sx={{ width: 1, display: "flex", justifyContent: "center", mt: 10 }}>
      <Typography sx={{ fontSize: 20 }}>{t("pageNotFound")}</Typography>
    </Box>
  );
}
